import { Icon } from '@material-ui/core';
import { Toast, toast } from 'react-hot-toast';
import styled, { keyframes } from 'styled-components';

const inAnimation = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const outAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const Wrapper = styled.div<{ visible: boolean }>`
  display: flex;
  gap: 16px;
  align-items: center;
  border-radius: 4px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0px 4px 4px 0px #00000040;
  height: 63px;
  border-left: 4px solid #ca8d57;
  padding-left: 22px;
  padding-right: 16px;
  background: #fff;
  width: calc(100vw - 56px);
  max-width: 600px;
  animation: ${props => (props.visible ? inAnimation : outAnimation)} 0.5s forwards;
`;

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="16" fill="#AF2930" />
    <circle cx="16" cy="16" r="16" fill="#CA8D57" />
    <path
      d="M17.2734 19.7413L14.8058 19.7413L14.8058 22.2089L17.2734 22.2089L17.2734 19.7413ZM17.2734 9.87064L14.8058 9.87064L14.8058 17.2736L17.2734 17.2736L17.2734 9.87064Z"
      fill="white"
    />
  </svg>
);

const Label = styled.span`
  color: #ca8d57;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
`;

const CloseIconWrapper = styled.div`
  margin-left: auto;
  display: flex;
  width: 24px;
  height: 24px;
  color: #424242;
`;

export const InfoToast = (props: Toast) => {
  return (
    <Wrapper visible={props.visible}>
      <InfoIcon />
      <Label>{props.message}</Label>
      <CloseIconWrapper onClick={() => toast.dismiss(props.id)}>
        <Icon>close</Icon>
      </CloseIconWrapper>
    </Wrapper>
  );
};
